import {
    Input
} from 'shared/components/ui/input';
import LabelWithTooltip from './LabelWithTooltip';

export default function InputWithTooltip({
    setter = ()=>{}, placeholder = '', required, label = '', value, type = 'text'
}) {
    return (
        <>
            <div className="mb-2">
                <div className="relative">
                    <div className="flex gap-1 items-center">
                        <LabelWithTooltip label={label}/>
                        {required && <span className="text-[red]">*</span>}
                    </div>
                    <Input placeholder={placeholder} type={type} onChange={(e)=> setter(e.target.value)} value={value}/>
                </div>
            </div>
        </>
    );
}